module.exports = __webpack_public_path__ + "static/slide-4-a0893d2f85633ea53953d24272ad6fb1.png";